import { DownloadableFile } from '@Components/DownloadableFile';
import { ApiSendEmailRequest } from '@Model';
import { Card, HtmlEditor, TextInputBase } from '@synqo/frontend-component-library';
import { Dispatch, FC, SetStateAction, useState } from 'react';

export interface EditEmailProps {
    sendEmailRequest: ApiSendEmailRequest;
    setSendEmailRequest: Dispatch<SetStateAction<ApiSendEmailRequest>>;
}

export const EditEmail: FC<EditEmailProps> = ({ sendEmailRequest, setSendEmailRequest }) => {
    const [initialEmailBody] = useState(sendEmailRequest.body);

    return (
        <>
            <TextInputBase
                name="recipient_email"
                label={'Email-Adresse der Empfänger'}
                required
                onChange={(value) => {
                    setSendEmailRequest({ ...sendEmailRequest, recipient_email_address: value });
                    return true;
                }}
                value={sendEmailRequest.recipient_email_address}
            />
            <TextInputBase
                name="reply_to"
                label={'Antwort an'}
                onChange={(value) => {
                    setSendEmailRequest({ ...sendEmailRequest, reply_to_email_address: value });
                    return true;
                }}
                value={sendEmailRequest.reply_to_email_address}
            />
            <TextInputBase
                name="subject"
                label={'Betreff'}
                onChange={(value) => {
                    setSendEmailRequest({ ...sendEmailRequest, subject: value });
                    return true;
                }}
                value={sendEmailRequest.subject}
            />
            <HtmlEditor
                value={initialEmailBody}
                onHtmlChange={(value) => {
                    setSendEmailRequest({ ...sendEmailRequest, body: value });
                }}
                allowImages
            />
            <Card name="attachments" label={'Anhänge'}>
                {sendEmailRequest.attachments.map((attachment) => (
                    <DownloadableFile key={attachment.file_name} {...attachment} />
                ))}
            </Card>
        </>
    );
};
